import type { Encounter, Reference } from '@medplum/fhirtypes'
import { createContext } from 'react'

export const QuestionnaireFormContext = createContext<{
  subject: Reference | undefined
  encounter: Reference<Encounter> | undefined
}>({
  subject: undefined,
  encounter: undefined,
})
